import { useIsServerSideRendering } from '@dbh/environment';
import { getDisplayName } from '@dbh/react-extra';
import { jsx } from 'react/jsx-runtime';

const withoutServerSideRendering=a=>{const b=b=>{const c=useIsServerSideRendering();return c?null:/*#__PURE__*/jsx(a,{...b})};return b.displayName="WithoutServerSideRendering("+getDisplayName(a)+")",b};

export { withoutServerSideRendering as default };
